// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Dx","backNav":"Ex","item":"Fx","disabled":"Gx","submitBtn":"Hx"};